import { default as balanceImg, default as currencyImg, default as transferImg } from "images/finvue/services/invoice-simplified-bg.jpg";
import React from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

import foreignExchangeImg1 from "images/new/foreign-exchange-img1.png";
import foreignExchangeImg2 from "images/new/foreign-exchange-img2.png";
import foreignExchangeImg3 from "images/new/foreign-exchange-img3.png";

interface ServiceCard {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
}

const services: ServiceCard[] = [
  {
    id: 1,
    title: "Comprehensive Currency Support",
    subtitle: "Supported Currencies",
    description: "Manage your money in multiple currencies with accounts made to match the way you do business.",
    image: foreignExchangeImg1,
  },
  {
    id: 2,
    title: "Simplify Global Transactions Globally",
    subtitle: "Multi-Currency Accounts",
    description: "Effortlessly manage funds in over 21 currencies. Enhance currency efficiency for your business and customers.",
    image: foreignExchangeImg2,
  },
  {
    id: 3,
    title: "Accelerate International Banking",
    subtitle: "Transfer Funds",
    description: "Improve transaction speeds and streamline cross-border payments effortlessly, 24/7, 365 days a year.",
    image: foreignExchangeImg3,
  },
];

const ExploreServicesSection: React.FC = () => {
  return (
    <section className="pt-6 bg-gray-50">
      <h2 className="text-2xl md:text-5xl font-normal text-center mb-16 max-w-5xl mx-auto">
        Explore more ways to
        <br />
        take your account global
      </h2>
      <div className="container mx-auto">
        <Swiper
          spaceBetween={24}
          slidesPerView={1.2}
          centeredSlides={false}
          className="!overflow-visible"
          breakpoints={{
            768: {
              slidesPerView: 2.2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {services.map((service) => (
            <SwiperSlide key={service.id}>
              <div className="bg-white rounded-3xl p-8 h-full">
                <div className="aspect-w-16 aspect-h-9 mb-8">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover rounded-2xl" />
                </div>

                <div className="space-y-4">
                  <div className="text-xs text-indigo-800">{service.subtitle}</div>
                  <h3 className=" text-lg md:text-xl font-normal">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ExploreServicesSection;
